import { z } from 'zod';
import { placeBundleSchema, placeSchema } from './shared';

export const bundleStateSchema = z.object({
  bundle: placeBundleSchema,
  place: placeSchema,
});

export type BundleState = z.infer<typeof bundleStateSchema>;
